import { useQuery } from '@tanstack/react-query';
import {
  PublisherResource,
  ShiftApplicationResource,
  TurnAssignmentCandidateResource,
  turnsAssignmentCandidates,
} from '~/generated';
import { extractData } from '~/utils/query-utils';

const sortCandidatesByAssignmentRatio = (
  candidates: TurnAssignmentCandidateResource[]
) =>
  candidates
    .map((candidate) => ({
      ...candidate,
      assignmentRatio:
        (candidate.assignmentRatioNumerator ?? 0) /
        (candidate.assignmentRatioDenominator ?? 0),
    }))
    .sort(
      (firstCandidate, secondCandidate) =>
        (secondCandidate.assignmentRatioDenominator ?? 0) -
          (firstCandidate.assignmentRatioDenominator ?? 0) ||
        firstCandidate.assignmentRatio - secondCandidate.assignmentRatio ||
        (
          (firstCandidate.application as ShiftApplicationResource)
            ?.publisher as PublisherResource
        ).lastName?.localeCompare(
          (
            (secondCandidate.application as ShiftApplicationResource)
              ?.publisher as PublisherResource
          )?.lastName ?? ''
        ) ||
        (
          (firstCandidate.application as ShiftApplicationResource)
            ?.publisher as PublisherResource
        )?.firstName?.localeCompare(
          (
            (secondCandidate.application as ShiftApplicationResource)
              ?.publisher as PublisherResource
          )?.firstName ?? ''
        )
    );

export const useCandidates = (args: { id: number }) =>
  useQuery({
    queryFn: () =>
      extractData(
        turnsAssignmentCandidates({
          path: { id: args.id },
          query: {
            expand: [
              'application.publisher.congregation',
              'application.publisher.language',
              'applicationsForThisDay',
              'applicationsOfPartnerForThisDay',
              'assignment',
            ],
          },
        })
      ),
    select: (data) => sortCandidatesByAssignmentRatio(data),

    queryKey: ['turns', args.id, 'candidates'],
  });
